import { service } from "../utils/request";
//充值订单备注
export function message(data) {
  return service({
    url: "manage/order.recharge/message",
    method: "post",
    data: data
  });
}
//加油订单备注
export function offline_order_msg(data) {
  return service({
    url: "manage/order.offline_order/message",
    method: "post",
    data: data
  });
}
//普通订单备注
export function normal_order_msg(data) {
  return service({
    url: "manage/order.normal_order/message",
    method: "post",
    data: data
  });
}
//用户列表
export function userList(data) {
  return service({
    url: "user/agent.User/index",
    method: "post",
    data: data
  });
}
//公告列表
export function noticeList(data) {
  return service({
    url: "manage/activity.notice/index",
    method: "get",
    params: data
  });
}
//公告详情
export function notice_info(data) {
  return service({
    url: "manage/activity.notice/info",
    method: "get",
    params: data
  });
}

// user/agent.User/detail
// 用户详情

export function userDetail(data) {
  return service({
    url: "user/agent.User/detail",
    method: "post",
    data: data
  });
}

export function userEdit(data) {
  return service({
    url: "user/agent.User/edit",
    method: "post",
    data: data
  });
}
// 设置支付密码
export function setPayPass(data) {
  return service({
    url: "agent/agent.index/setPayPass",
    method: "post",
    data: data
  });
}
// 验证支付密码
export function verifyPass(data) {
  return service({
    url: "shop/agent.index/verifyPass",
    method: "post",
    data: data
  });
}

// 添加分销等级
export function addSpread(data) {
  return service({
    url: "spread/agent.level/add",
    method: "post",
    data: data
  });
}

// 分销等级列表
export function getlevel(data) {
  return service({
    url: "spread/agent.level/index",
    method: "post",
    data: data
  });
}

// 删除分销等级
export function dellevel(data) {
  return service({
    url: "spread/agent.level/del",
    method: "post",
    data: data
  });
}

// 修改分销状态
export function change_spread(data) {
  return service({
    url: "spread/agent.level/status",
    method: "post",
    data: data
  });
}

// 分销等级详情
export function level_detail(data) {
  return service({
    url: "spread/agent.level/detail",
    method: "post",
    data: data
  });
}

// 修改分销等级
export function edit_level_detail(data) {
  return service({
    url: "spread/agent.level/edit",
    method: "post",
    data: data
  });
}

// 分销结算设置
export function settle_setting(data) {
  return service({
    url: "spread/agent.settle_setting/config",
    method: "post",
    data: data
  });
}

// 分销结算设置详情
export function set_settingDetail(data) {
  return service({
    url: "spread/agent.settle_setting/detail",
    method: "post",
    data: data
  });
}

// 分销设置
export function setting_spread(data) {
  return service({
    url: "spread/agent.setting/config",
    method: "post",
    data: data
  });
}

// 分销详情
export function get_spread_detail(data) {
  return service({
    url: "spread/agent.setting/detail",
    method: "post",
    data: data
  });
}

// 分销协议添加
export function add_spread_text(data) {
  return service({
    url: "spread/agent.setting/addArt",
    method: "post",
    data: data
  });
}

// 分销协议修改
export function edit_spread_text(data) {
  return service({
    url: "spread/agent.setting/editArt",
    method: "post",
    data: data
  });
}

// 分销协议获取
export function get_spread_text(data) {
  return service({
    url: "spread/agent.setting/article",
    method: "post",
    data: data
  });
}

// 分销商申请列表
export function getspread_list(data) {
  return service({
    url: "spread/agent.apply/lst",
    method: "post",
    data: data
  });
}

// 驳回分销商申请
export function RefueSeread(data) {
  return service({
    url: "spread/agent.apply/refuse",
    method: "post",
    data: data
  });
}

// 通过分销申请
export function AgreeSeread(data) {
  return service({
    url: "spread/agent.apply/agree",
    method: "post",
    data: data
  });
}

// 编辑分享设置
export function setShareConfig(data) {
  return service({
    url: "spread/agent.share/config",
    method: "post",
    data: data
  });
}

// 获取分享设置
export function getShareConfig(data) {
  return service({
    url: "spread/agent.share/detail",
    method: "post",
    data: data
  });
}

// 提现列表
export function getWithdrawList(data) {
  return service({
    url: "spread/agent.withdrawal/index",
    method: "post",
    data: data
  });
}

// 提现详情
export function getWithdrawDetail(data) {
  return service({
    url: "spread/agent.withdrawal/index",
    method: "post",
    data: data
  });
}

// 通过提现申请
export function withdrawAgree(data) {
  return service({
    url: "spread/agent.withdrawal/auditAgree",
    method: "post",
    data: data
  });
}

// 驳回提现申请
export function withdrawRefuse(data) {
  return service({
    url: "spread/agent.withdrawal/auditRefuse",
    method: "post",
    data: data
  });
}

// 提现打款成功
export function withdrawSuccess(data) {
  return service({
    url: "spread/agent.withdrawal/paymentSuccess",
    method: "post",
    data: data
  });
}

// 提现打款失败
export function withdrawFail(data) {
  return service({
    url: "spread/agent.withdrawal/paymentFail",
    method: "post",
    data: data
  });
}

// 分销商列表
export function getSpreadList(data) {
  return service({
    url: "spread/agent.users/index",
    method: "post",
    data: data
  });
}

// 分销佣金记录
export function getSpreadMoney(data) {
  return service({
    url: "spread/agent.users/commissionLogs",
    method: "post",
    data: data
  });
}

// 分销充值记录
export function getSpreadRecharge(data) {
  return service({
    url: "spread/agent.users/spreadRecharge",
    method: "post",
    data: data
  });
}

// 分销订单记录
export function getSpreadOrder(data) {
  return service({
    url: "spread/agent.users/spreadOrder",
    method: "post",
    data: data
  });
}

// 分销用户记录
export function getSpreadUser(data) {
  return service({
    url: "spread/agent.users/spreadUsers",
    method: "post",
    data: data
  });
}

// 分销概况
export function getSpreadCount(data) {
  return service({
    url: "spread/agent.index/count",
    method: "post",
    data: data
  });
}

// 修改分销商等级
export function changeSpreadLevel(data) {
  return service({
    url: "spread/agent.level/changeUserLevel",
    method: "post",
    data: data
  });
}

// 获取用户会员卡信息
export function getRechargeInfo(data) {
  return service({
    url: "manage/order.recharge/userInfo",
    method: "post",
    data: data
  });
}

//获取地区
export function get_area(data) {
  return service({
    url: "shop/agent.express/getarea",
    method: "post",
    data: data
  });
}
